import * as React from 'react';

import type {ListOption} from 'shells/select-option-components/option';

import type {TagType} from 'nutshell-graphql-types';

import {GraphQLSelectTagsOld} from '../../../../../core/select/graphql-select-tags-old';
import {GraphQLSelectTagsProvider} from '../../../../../core/select/graphql-select-tags-provider';

type Props = {
    tagType: TagType;
    onChange: (option: ListOption) => void;
    selectedId: string | null | undefined;
    excludeIds?: string[];
};

export function SelectTag(props: Props): React.ReactElement {
    const [inputValue, setInputValue] = React.useState<string>('');
    const [tagOptions, setTagOptions] = React.useState<ListOption[]>([]);

    const {tagType, onChange, selectedId, excludeIds} = props;

    return (
        <GraphQLSelectTagsProvider tagType={tagType} searchTerm={inputValue}>
            {({options, isLoading, refetch, fetchMoreTags}) => {
                // if the user searches or fetches more and we fetch a new option not included in tagOptions, add it to the list
                if (options.length && tagOptions.length !== options.length) {
                    const filteredOptions = options.filter(
                        (option) => !tagOptions.find((opt) => opt.value === option.value)
                    );
                    if (filteredOptions.length) {
                        setTagOptions(tagOptions.concat(filteredOptions));
                    }
                }

                if (selectedId && !tagOptions.find((option) => option.value === selectedId)) {
                    fetchMoreTags();
                }

                return (
                    <GraphQLSelectTagsOld
                        onChange={onChange}
                        options={
                            excludeIds
                                ? tagOptions.filter((option) => !excludeIds.includes(option.value))
                                : tagOptions
                        }
                        selectedId={selectedId}
                        refetch={refetch}
                        isLoading={isLoading}
                        tagType={tagType}
                        updateOptions={(newValue: ListOption) =>
                            setTagOptions(tagOptions.concat(newValue))
                        }
                        // @ts-expect-error
                        onInputChange={(searchTerm: string) => setInputValue(searchTerm || '')}
                        isCreateable={true}
                    />
                );
            }}
        </GraphQLSelectTagsProvider>
    );
}
